import { classNames, useState, useEffect } from 'libs/react';
import { useQuery } from 'libs/react';
import { React } from 'libs/react';
import { FormSelect } from 'components/form/FormSelect';
import { gql } from '@apollo/client';
/**
 * @component FormClientSelect
 * @since 1.0.0
 */
export function FormClientSelect(props) {
    var _a;
    const { style } = Object.assign({ style: 'normal' }, props);
    const [currentValue, setCurrentValue] = useState(props.value);
    const [data] = useQuery(gql `
      query ClientListQuery($input: ClientsInput!) {
        clients(input: $input) {
          items {
            id
            name
            number
          }
        }
      }
    `, {
        variables: {
            input: {
                isEndClient: props.isEndClient
            }
        }
    });
    const options = (_a = data === null || data === void 0 ? void 0 : data.clients.items.map((group) => ({
        value: group.id,
        label: group.name
    }))) !== null && _a !== void 0 ? _a : [];
    useEffect(() => {
        if (props.filter) {
            if (props.filter['number']) {
                const selectedClient = data === null || data === void 0 ? void 0 : data.clients.items.find((client) => { var _a, _b, _c; return ((_a = client.number) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = props.filter) === null || _b === void 0 ? void 0 : _b['number']) !== null && _c !== void 0 ? _c : ''); });
                if (selectedClient) {
                    setCurrentValue(selectedClient.id);
                }
            }
        }
    }, [data]);
    const className = classNames('form-sale-item-group', 'form-sale-item-group--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-sale-item-group-field" },
            React.createElement(FormSelect, Object.assign({}, props, { options: options, value: currentValue })))));
}
